var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.962 4.737a4.1 4.1 0 0 1 2.261 1.368l.492.579 1.917-2-.541-.58C11.01 2.948 9.584 2.264 7.913 2V0H5.407v2C2.654 2.37.787 4.158.787 6.474c0 2.947 2.506 3.842 4.62 4.421v4.421a5.684 5.684 0 0 1-2.999-1.684l-.54-.58L0 15.106l.492.527c1.18 1.316 2.9 2.21 4.866 2.421V20h2.506v-1.947c3.49-.474 4.718-2.684 4.718-4.737.099-3.158-2.654-4.21-4.62-4.737V4.737zm0 10.579v-3.737c1.376.474 1.917 1 1.917 1.842 0 .368-.148 1.526-1.917 1.895zM5.456 4.684v3.158C4.178 7.421 3.686 7 3.686 6.368c0-.737.688-1.421 1.77-1.684z",
    fill: "gray",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.2c653808e82f52a52d80d59023c4af32.svg";
export { ForwardRef as ReactComponent };